import {HostProofSection} from './host-proof-section/HostProofSection'
import {GuestProofSection} from './guest-proof-section/GuestProofSection'
import {GoalV3} from '@/features/chat/chat.model'

export type ProofSectionType = {
    goal?: GoalV3
    isHost?: boolean
    translatedProofNote?: JSX.Element
}

export const ProofSection = ({goal, isHost, translatedProofNote}: ProofSectionType) => {
    return isHost ? (
        <HostProofSection goal={goal} />
    ) : (
        <GuestProofSection goal={goal} translatedProofNote={translatedProofNote} />
    )
}
